import { AxiosInstance } from 'axios';
import axiosInstance from './axios_instance';

const ApiPathLogin = "/login";

class AuthService {
    private instance: AxiosInstance;

    constructor(navigate: any) {
        this.instance = axiosInstance(navigate);
    }

    async login(username: string, password: string) {
        try {
            let response = await this.instance.post(ApiPathLogin, { username, password });
            if (response.data.accessToken) {
                localStorage.setItem('accessToken', response.data.accessToken);
            }

            return response.data;
        } catch(e) {
            console.error(`failed to login: ${JSON.stringify(e)}`);
        }
    }

    logout() {
        localStorage.removeItem('accessToken');
    }

    getAccessToken() {
        return localStorage.getItem('accessToken');
    }

    isAuthenticated() {
        return this.getAccessToken() !== null;
    }
}

let authServiceInstance: AuthService;

export const getAuthServiceInstance = (navigate: any): AuthService => {
    if (authServiceInstance === undefined) {
        authServiceInstance = new AuthService(navigate)
    }

    return authServiceInstance
}
